import { render, staticRenderFns } from "./issuereceivedetail.vue?vue&type=template&id=5a34b86f&scoped=true&"
import script from "./issuereceivedetail.vue?vue&type=script&lang=js&"
export * from "./issuereceivedetail.vue?vue&type=script&lang=js&"
import style0 from "./issuereceivedetail.vue?vue&type=style&index=0&id=5a34b86f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34b86f",
  null
  
)

export default component.exports